<template>
  <div class="edit-active-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="90px">
        <el-form-item label="标题:" prop="title">
          <el-input v-model="params.title" size="small" placeholder="请输入活动标题"></el-input>
        </el-form-item>

        <el-form-item label="活动描述:" prop="desc">
          <el-input type="textarea" :rows="3" placeholder="请输入活动描述" v-model="params.desc"></el-input>
        </el-form-item>

        <el-form-item label="开始时间:" prop="startTime">
          <el-date-picker v-model="params.startTime" type="datetime" :editable="false" placeholder="请输入开始时间" size="small"></el-date-picker>
        </el-form-item>

        <el-form-item label="结束时间:" prop="endTime">
          <el-date-picker v-model="params.endTime" type="datetime" :editable="false" placeholder="请输入结束时间" size="small"></el-date-picker>
        </el-form-item>

        <el-form-item label="是否开启:" v-if="type == 'edit'">
          <el-switch v-model="params.status"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
export default {
  data() {
    return {
      dialogVisible: false,
      title: "新增活动",
      flag: false,
      type: "", //表单类型
      params: {
        title: "",
        desc: "",
        startTime: "",
        endTime: "",
        status: false,
      },
      // 表单验证规则
      rules: {
        title: [{ required: true, message: "请输入活动标题", trigger: "blur" }],
        desc: [{ required: true, message: "请输入活动描述", trigger: "blur" }],
        startTime: [
          { required: true, message: "请输入开始时间", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "请输入结束时间", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "edit") {
            this.editActive();
          }
          if (this.type == "add") {
            this.addContent();
          }
        } else {
          return false;
        }
      });
    },
    // 新增活动
    addContent() {
      let params = Object.assign({}, this.params);
      API.addWebActivity(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.$emit("handlerList");
          } else {
            this.$message.error(res.msg || "新增失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑活动
    editActive() {
      let params = Object.assign({}, this.params);
      API.editWebActive(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.$emit("handlerList");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        title: "",
        desc: "",
        status: false,
        startTime: "",
        endTime: "",
      };
    },

    // 打开编辑活动弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      this.type = type;
      if (type === "edit") {
        this.title = "编辑活动";
        this.params = Object.assign({}, data);
      }
    },
  },
};
</script>
<style lang="scss" >
.edit-active-box {
  .el-input {
    width: 200px;
  }
  .el-dialog {
    margin-top: 50px !important;
  }
}
</style>
